/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SummarizationsControllerGetFileContentQueryResponse, SummarizationsControllerGetFileContentPathParams, SummarizationsControllerGetFileContent404 } from "../../models/documentSummariesController/SummarizationsControllerGetFileContent";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { summarizationsControllerGetFileContent } from "../../clients/document-summariesService/summarizationsControllerGetFileContent";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const summarizationsControllerGetFileContentQueryKey = (documentId: SummarizationsControllerGetFileContentPathParams["documentId"], renditionId: SummarizationsControllerGetFileContentPathParams["renditionId"], summaryId: SummarizationsControllerGetFileContentPathParams["summaryId"]) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/summaries/:summaryId/content',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    summaryId: summaryId
  }
}] as const;
export type SummarizationsControllerGetFileContentQueryKey = ReturnType<typeof summarizationsControllerGetFileContentQueryKey>;
export function summarizationsControllerGetFileContentQueryOptions(documentId: SummarizationsControllerGetFileContentPathParams["documentId"], renditionId: SummarizationsControllerGetFileContentPathParams["renditionId"], summaryId: SummarizationsControllerGetFileContentPathParams["summaryId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = summarizationsControllerGetFileContentQueryKey(documentId, renditionId, summaryId);
  return queryOptions<SummarizationsControllerGetFileContentQueryResponse, ResponseErrorConfig<SummarizationsControllerGetFileContent404>, SummarizationsControllerGetFileContentQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && summaryId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return summarizationsControllerGetFileContent(documentId, renditionId, summaryId, config);
    }
  });
}

/**
 * @description Retrieves the actual text content of a summary. First checks the database for inline content, then falls back to S3 storage if a storage location is specified.
 * @summary Get summary content
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/summaries/:summaryId/content}
 */
export function useSummarizationsControllerGetFileContent<TData = SummarizationsControllerGetFileContentQueryResponse, TQueryData = SummarizationsControllerGetFileContentQueryResponse, TQueryKey extends QueryKey = SummarizationsControllerGetFileContentQueryKey>(documentId: SummarizationsControllerGetFileContentPathParams["documentId"], renditionId: SummarizationsControllerGetFileContentPathParams["renditionId"], summaryId: SummarizationsControllerGetFileContentPathParams["summaryId"], options: {
  query?: Partial<QueryObserverOptions<SummarizationsControllerGetFileContentQueryResponse, ResponseErrorConfig<SummarizationsControllerGetFileContent404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? summarizationsControllerGetFileContentQueryKey(documentId, renditionId, summaryId);
  const query = useQuery({
    ...summarizationsControllerGetFileContentQueryOptions(documentId, renditionId, summaryId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SummarizationsControllerGetFileContent404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}